import { store } from '../store';

class Navigation {
    constructor(args) {
        args = args || {};
        this.homeButton = document.querySelector('.navigation-mobile .btn-home');
        this.homeButtonMobile = document.querySelector('.btn-home');
        this.scroll = args.scroll || null;
        this.menuOpen = false;
        this.subNav = document.querySelector('.navigation-mobile .menu-items');
        this.nav = document.querySelector('.navigation');
        this.buttonMobile = document.querySelector('.btn-menu-mobile');
        this.menuItems = document.querySelectorAll('.menu-items button');
        this.menuItemsMobile = document.querySelectorAll('.navigation-mobile .menu-items');
        this.submenuItems = document.querySelectorAll('.menu-items button ul li a');
        this.menu = document.querySelector('.btn-menu');
        this.closeButton = document.querySelector('.btn-close');
        this.closeButtonMobile = document.querySelector('.navigation-mobile .btn-close');
        this.controls = document.querySelector('.navigation .controls');
        this.activeId = null;
        this.galleryMenuActive = false;
        this.navigationVisible = true;
        this.gallery4xGrid = document.querySelector('.btn-gallery4x');
        this.gallery2xGrid = document.querySelector('.btn-gallery2x');
        this.galleryFull = document.querySelector('.btn-galleryFull');
        this.navigationBackground = document.querySelector('.navigation__background');
        // N-01 nav grid. Keyed by the menu button's id, which matches
        // data-nav-grid in the markup.
        this.navGrids = document.querySelectorAll('.nav-grid');
        this.navigationBackgroundMobile = document.querySelector('.navigation-mobile .navigation__background');
        this.setupListeners();
    }

    /**
     * Point the nav at the current page's gallery. Listeners read `this.gallery`
     * at click time, so they only need binding once — in setupListeners().
     */
    attachGallery(gallery) {
        this.gallery = gallery || null;
    }

    setupListeners() {
        // mobile button
        if (this.buttonMobile) {
            this.buttonMobile.addEventListener('click', () => {
                this.mobileOpenNav();
            });
        }

        // menu button
        if (this.menu) {
            this.menu.addEventListener('click', (e) => {
                e.preventDefault();
                store.dispatch({ type: "TOGGLE_NAVIGATION_VISABILITY", payload: !this.navigationVisible });
            });
        }

        // home buttons
        const onHomeClick = (e) => {
            e.preventDefault();
            this.subNav && this.subNav.classList.remove('mobileShow');
            this.closeAlreadyActiveMenuItems();
            this.navigationBackground && this.navigationBackground.classList.add('closed');
            this.navigationBackgroundMobile && this.navigationBackgroundMobile.classList.add('closed');
            return true;
        };

        this.homeButton && this.homeButton.addEventListener('click', onHomeClick);
        this.homeButtonMobile && this.homeButtonMobile.addEventListener('click', onHomeClick);

        // main navigation
        this.menuItems.forEach((item) => {
            item.addEventListener('mouseenter', (e) => {
                if (e.target.classList.contains('nosub')) {
                    this.closeAlreadyActiveMenuItems();
                    this.navigationBackground && this.navigationBackground.classList.add('closed');
                    this.showNavGrid(null);
                    return true;
                }

                e.preventDefault();
                this.nav && this.nav.classList.add('noblend');
                this.closeAlreadyActiveMenuItems();
                this.navigationBackground && this.navigationBackground.classList.remove('closed');
                this.menuOpen = true;
                this.activeId = e.target.id;
                e.target.classList.add('active');
                // Hover shows the text list only. The grid is a click.
                this.showNavGrid(null);
            });
        });

        // Click a primary header: the text list goes away and the grid of that
        // section's sub-items takes its place. Hover and click are deliberately
        // different states, not two routes to the same thing.
        this.menuItems.forEach((item) => {
            item.addEventListener('click', (e) => {
                if (item.classList.contains('nosub')) return;

                // Let the submenu's own links through — but only actual links.
                // The open <ul> is absolutely positioned from top:0 with 55px of
                // padding, so it covers the header label itself; testing for the
                // <ul> here meant every click on the header hit the list's
                // padding and bailed, which is why nothing happened at all.
                if (e.target.closest && e.target.closest('a')) return;

                e.preventDefault();
                this.closeAlreadyActiveMenuItems();
                this.nav && this.nav.classList.add('noblend');
                this.navigationBackground && this.navigationBackground.classList.remove('closed');
                this.menuOpen = true;
                this.activeId = item.id;
                this.showNavGrid(item.id);
            });
        });

        // The grid scrolls on its own. Locomotive's VirtualScroll binds `wheel`
        // on window in the bubble phase, so it would otherwise drive the page
        // behind the overlay instead. Stopping propagation here keeps the wheel
        // local to the grid; overscroll-behavior: contain in CSS stops the page
        // taking over once the grid hits its end.
        this.navGrids.forEach((grid) => {
            grid.addEventListener('wheel', (e) => {
                e.stopPropagation();
            }, { passive: true });
        });

        // Bound once. This used to sit inside the menuItems loop, which added a
        // duplicate background listener for every item in the menu.
        if (this.navigationBackground) {
            this.navigationBackground.addEventListener('click', () => {
                if (!this.menuOpen) return;

                this.closeAlreadyActiveMenuItems();
                this.navigationBackground.classList.add('closed');

                clearTimeout(this.noblendTimer);
                this.noblendTimer = setTimeout(() => {
                    this.nav && this.nav.classList.remove('noblend');
                }, 1000);
            });
        }

        // submenu navigation
        this.submenuItems.forEach((item) => {
            item.addEventListener('click', (e) => {
                this.subNav && this.subNav.classList.remove('mobileShow');
                this.navigationBackgroundMobile && this.navigationBackgroundMobile.classList.add('closed');
                if (e.target.parentNode.parentNode.parentNode) {
                    e.target.parentNode.parentNode.parentNode.classList.remove('active');
                }
            });
        });

        // Escape closes the panel. The brief asks for this and there was no
        // keyboard route out of the menu at all before.
        this.onNavKeydown = (e) => {
            if (e.key !== 'Escape' || !this.menuOpen) return;
            this.closeAlreadyActiveMenuItems();
            this.navigationBackground && this.navigationBackground.classList.add('closed');
            this.showNavGrid(null);
            this.menuOpen = false;
        };
        document.addEventListener('keydown', this.onNavKeydown);

        // gallery buttons
        this.gallery4xGrid && this.gallery4xGrid.addEventListener('click', () => {
            this.gallery && this.gallery.setGalleryMode('layout4x');
        });

        this.gallery2xGrid && this.gallery2xGrid.addEventListener('click', () => {
            this.gallery && this.gallery.setGalleryMode('layout2x');
        });

        this.galleryFull && this.galleryFull.addEventListener('click', () => {
            this.gallery && this.gallery.setGalleryMode('layoutFull');
            this.hideGalleryMenu();
        });

        // gallery close buttons
        const onCloseClick = () => {
            this.gallery && this.gallery.closeGallery();
        };

        this.closeButton && this.closeButton.addEventListener('click', onCloseClick);
        this.closeButtonMobile && this.closeButtonMobile.addEventListener('click', onCloseClick);
    }

    /**
     * Reveal one section's grid, or none. Passing null clears them all, which
     * is what hover, Info (nosub) and Escape all want.
     */
    showNavGrid(id) {
        this.navGrids.forEach((grid) => {
            grid.classList.toggle('is-visible', grid.getAttribute('data-nav-grid') === id);
        });
    }

    closeAlreadyActiveMenuItems() {
        this.menuItems.forEach((item) => {
            item.classList.remove('active');
        });
    }

    toggleGalleryMenu(state) {
        this.galleryMenuActive = state;
        state ? this.showGalleryMenu() : this.hideGalleryMenu();
    }

    hideGalleryMenu() {
        this.controls && this.controls.classList.remove('active');
    }

    showGalleryMenu() {
        this.controls && this.controls.classList.add('active');
    }

    toggleVisibility(state) {
        if (!this.nav) return;

        if (state) {
            this.nav.classList.remove('hidden');
            this.navigationVisible = true;
        } else {
            this.nav.classList.add('hidden');
            this.navigationVisible = false;
        }
    }

    onChange(state) {
        this.toggleVisibility(state.navigationVisible);
    }

    reset() {
        this.hideGalleryMenu();
        this.showNavGrid(null);
        this.navigationBackground && this.navigationBackground.classList.add('closed');
        this.navigationBackgroundMobile && this.navigationBackgroundMobile.classList.add('closed');
    }

    hideMainButton() {
        this.menu && this.menu.classList.add('hidden');
        this.buttonMobile && this.buttonMobile.classList.add('hidden');
        this.closeButton && this.closeButton.classList.add('active');
        this.closeButtonMobile && this.closeButtonMobile.classList.add('active');
    }

    showMainButton() {
        this.menu && this.menu.classList.remove('hidden');
        this.buttonMobile && this.buttonMobile.classList.remove('hidden');
        this.closeButton && this.closeButton.classList.remove('active');
        this.closeButtonMobile && this.closeButtonMobile.classList.remove('active');
    }

    mobileOpenNav() {
        this.navigationBackgroundMobile && this.navigationBackgroundMobile.classList.remove('closed');
        this.subNav && this.subNav.classList.add('mobileShow');
    }
}

export default Navigation;
